import React, { useState } from 'react';
import Input, { InputProps } from '../ui/Inputs/Input';
import Select, { SelectProps } from '../ui/Inputs/Select';

interface FilterField extends Partial<InputProps & SelectProps> {
  type: string;
}

interface FiltersProps {
  values: Record<string, string>;
  filtersSchema: Record<string, FilterField>;
  setFilter: (filter: string, value: string) => void;
  className?: string;
}

const getInputField = (fieldProps: FilterField) => <Input {...fieldProps} />;

const getSelectField = ({ options, ...fieldProps }: FilterField) => (
  <Select options={options ?? []} {...fieldProps} />
);

const Filters = ({
  values,
  filtersSchema,
  setFilter,
  className,
}: FiltersProps) => (
  <aside className={className} style={{ minWidth: '15rem', maxWidth: '20vw' }}>
    <h3 className="mb-4">Фильтры</h3>

    {Object.entries(filtersSchema).map(([name, filterField]) => {
      const filterFieldWithOnChange = {
        ...filterField,
        name,
        key: name,
        value: values[name],
        onChange: (value: string) => {
          setFilter(name, value);
          filterField?.onChange?.(value);
        },
      };

      if (filterField.type === 'select') {
        return getSelectField(filterFieldWithOnChange);
      }

      return getInputField(filterFieldWithOnChange);
    })}
  </aside>
);

Filters.defaultProps = {
  className: '',
};

export const useFilters = (
  defaultFilters: Record<string, string>,
): [Record<string, string>, (filter: string, value: string) => void] => {
  const [filters, setFilters] = useState(defaultFilters);

  const setFilter = (filter: string, value: string) => {
    setFilters((prev) => ({ ...prev, [filter]: value }));
  };

  return [filters, setFilter];
};

export default Filters;
